<template>
  <div class="card-scene">
    <Container
      orientation="!horizontal"
      drag-handle-selector=".column-drag-handle"
      @drag-start="dragStart"
      :drop-placeholder="upperDropPlaceholderOptions"
    >
      <Draggable v-for="column in cardGrp" :key="column.id">
        <div :class="column.props.className">
          <Container
            group-name="col"
            @drop="e => onCardDrop(column.id, e)"
            :get-child-payload="getCardPayload()"
            drag-class="card-ghost"
            drop-class="card-ghost-drop"
            :drop-placeholder="dropPlaceholderOptions"
          >
            <Draggable v-for="(data, i) in list" :key="i">
              <div class="card">
                <slot name="card" :card="data" :index="i" />
              </div>
            </Draggable>
          </Container>
        </div>
      </Draggable>
    </Container>
  </div>
</template>

<script>
import { Container, Draggable } from "vue-dndrop";
import { applyDrag } from "@/components/drag-event";

export default {
  name: "CardsDrag",
  components: { Container, Draggable },
  props: {
    horizontal: {
      default: false,
    },
    cardGrpCnt: {
      Type: Number,
      default: 1,
    },
    list: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      cardGrp: [
        {
          id: "cardgroup",
          type: "container",
          props: {
            orientation: "vertical",
            className: "card-container",
          },
        },
      ],
      upperDropPlaceholderOptions: {
        className: "cards-drop-preview",
        animationDuration: "150",
        showOnTop: true,
      },
      dropPlaceholderOptions: {
        className: "drop-preview",
        animationDuration: "150",
        showOnTop: true,
      },
    };
  },
  methods: {
    init() {},
    onCardDrop(columnId, dropResult) {
      if (dropResult.removedIndex !== null || dropResult.addedIndex !== null) {
        let list = Object.assign(this.list);
        list = applyDrag(list, dropResult);

        this.list = list;
      }
    },
    getCardPayload() {
      return index => {
        return this.list[index];
      };
    },
    dragStart() {
      // this.$log.info("drag started");
    },
  },
};
</script>
